




import HelloWorld from '@/components/HelloWorld.vue';
import UserMenu from '@/components/UserMenu.vue';
import SideMenu from '@/components/SideMenu.vue';
import { db } from '@/plugins/firebase';
import { Component, Vue } from 'vue-property-decorator';
import firebase from 'firebase';
import store from '@/store/store';
import { User } from '@/types';
import Notifications from '@/store/modules/notifications';
import { getModule } from 'vuex-module-decorators';
import Auth from './store/modules/auth';
const notificationModule = getModule(Notifications, store);
const authModule = getModule(Auth, store);

@Component({
  components: {
    SideMenu,
    UserMenu,
  },
})
export default class App extends Vue {
  created() {
    firebase
      .auth()
      .onAuthStateChanged(async (userInfo: firebase.User | null) => {
        if (userInfo) {
          let user = await this.$db.getUserData(userInfo.uid);
          // 初回ログインでまだDBにデータがない場合
          if (!user) {
            user = <User>{
              displayName: userInfo.displayName,
              photoURL: userInfo.photoURL,
              uid: userInfo.uid,
              level: 1,
              exp: 0,
              charCount: 0,
              stoneCount: 0,
              likeCount: 0,
            };
          }
          authModule.setUser({ user: user });
          notificationModule.bind({ uid: user.uid });
        } else {
          authModule.setUser({ user: null });
          notificationModule.unbind();
          //this.$router.push('/');
        }
      });
  }
}
